import React from "react";
import { useTranslation } from "react-i18next";
import { BadgeCheck, ShieldCheck } from "lucide-react";

const Btn = ({ Icon, label, active, onClick }) => (
    <button
        type="button"
        aria-pressed={active}
        onClick={onClick}
        className={`flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-full border transition-colors ${
            active
                ? "bg-blue-50 text-blue-700 border-blue-200"
                : "bg-background text-muted-foreground border-border hover:text-foreground"
        }`}
    >
        <Icon className="h-3.5 w-3.5" />
        {label}
    </button>
);

// Toggles `agentui_verified` and `security_verified` independently.
// `value` is the selected badge array; parent serializes to API as
// comma-separated `badges` query param.
export function VerificationFilter({ value = [], onChange }) {
    const { t } = useTranslation();
    const has = (b) => value.includes(b);
    const toggle = (b) =>
        onChange(has(b) ? value.filter((x) => x !== b) : [...value, b]);

    return (
        <div className="flex flex-wrap items-center gap-2">
            <span className="text-xs text-muted-foreground mr-1">
                {t("blueprints.filterByVerification")}:
            </span>
            <Btn
                Icon={BadgeCheck}
                label={t("blueprints.agentuiVerified")}
                active={has("agentui_verified")}
                onClick={() => toggle("agentui_verified")}
            />
            <Btn
                Icon={ShieldCheck}
                label={t("blueprints.securityVerified")}
                active={has("security_verified")}
                onClick={() => toggle("security_verified")}
            />
        </div>
    );
}

export default VerificationFilter;
